import reducer from "./reducer"
import saga from "./saga"
import { MODULE_NAME } from "./helpers"

export {
  loadCalendar,
  initCalendar,
  addEvent,
  updateEvent,
  removeEvent,
} from "./actions/creators"
export {
  selectCalendarData,
  selectCalendarMeta,
  selectEvent,
} from "./selectors"

const name = MODULE_NAME
export { name, reducer, saga }
